<template>
    <div>
        <div class="loading-catalog" v-if="products.length === 0">Загрузка каталога</div>
        <div v-else>
          <div class="catalog-group" v-for="(group, groupIndex) in groups" :key="group.id" :id="group.group">
            <a class="product-list-title"><span class="pp-icon" :class="[group.icon_class]"></span>{{group.title}}</a>
            <div class="product-list">
              <CatalogElement v-for="(product, index) in products[group.id]" :key="product.id"
                           :catalogElement="{'element': product, 'pagination': {'groupIndex': groupIndex, 'productIndex': index, 'groupProductCount': products[group.id].length}}" ></CatalogElement>
            </div>
          </div>
        </div>

        <ProductLargeCard v-show="selectedEntity !== null"></ProductLargeCard>

        <ErrorNotification :error="basketError" v-if="basketError !== null"></ErrorNotification>
    </div>
</template>

<script>
    import Utils from "../Utils.vue";
    import {mapGetters} from 'vuex';
    import CatalogElement from "@/components/catalog/CatalogElement.vue";
    import ProductLargeCard from "@/components/catalog/ProductLargeCard.vue";
    import ErrorNotification from "@/components/catalog/ErrorNotification.vue";

    export default {
        name: "Catalog",
        components: {
          ErrorNotification,
          ProductLargeCard,
          CatalogElement,
        },
        data: function () {
            return {}
        },
        computed:{
            ...mapGetters('catalog', {
                products: 'getProducts',
                groups: 'getGroups',
                selectedEntity: 'getSelectedProductLargeCard',
                productShares: 'getProductShares',
                combos: 'getCombos'
            }),
            ...mapGetters('basket', {
                basketError: "getError"
            }),
            ...mapGetters("combo", {
              selectedCombo: 'getCombo'
            })
        },
        methods: {},
        mounted() {},
        mixins: [Utils]
    }
</script>

<style scoped>

</style>
